const WIDTH = 200;
const HEIGHT = 10;
const TINT = 0xf1c40f;

export default class Cooldown extends Phaser.GameObjects.Sprite {
    private tween: Phaser.Tweens.Tween | null;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x - WIDTH / 2, y, 'atlas', 'blank');

        this.setDisplaySize(WIDTH, HEIGHT);
        this.setTint(TINT);
        this.setOrigin(0, 0.5);

        this.tween = null;

        this.displayWidth = 0;
    }

    start(duration: number) {
        this.tween?.stop();
        this.displayWidth = WIDTH;

        this.tween = this.scene.tweens.add({
            targets: this,
            duration,
            ease: Phaser.Math.Easing.Linear,
            displayWidth: 0,
        });
    }

    destroy() {
        this.tween?.stop();
        super.destroy();
    }
}
